import React from 'react';
import './index.css';
import { DeptBadgeProps } from '../../redux/AllocationRequest';

export const DeptBadge: React.FC<DeptBadgeProps> = ({ dept }) => {
  const isSales = dept === "Sales & Marketing";
  const icon = isSales ? "📣" : "🚚";
  
  return (
    <span className={`dept-badge ${isSales ? 'dept-badge-sales' : 'dept-badge-distribution'}`}>
      {icon} {dept}
    </span>
  );
};